import { render, staticRenderFns } from "./BeeVideoZone.vue?vue&type=template&id=0348d830&"
import script from "./BeeVideoZone.vue?vue&type=script&lang=js&"
export * from "./BeeVideoZone.vue?vue&type=script&lang=js&"
import style0 from "./BeeVideoZone.vue?vue&type=style&index=0&id=0348d830&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports